import React, { useEffect } from 'react'
import DeleteOutlined from '@ant-design/icons/DeleteOutlined'

import { LntButton } from '@app/components/base'

import { BUTTON_TYPE, SIZE } from '@app/constants'

import styles from '../styles.module.scss'

import type { Column } from '@app/components/base/Table/types'

export interface UseDependentProductColumnParams<DataSourceType> {
  columns: Array<Column<DataSourceType>>
  onClickDelete: (record: DataSourceType) => void
}

export const useDependentProductColumn = <DataSourceType extends { key: string }>({
  columns,
  onClickDelete
}: UseDependentProductColumnParams<DataSourceType>): void => {
  useEffect(() => {
    const actionsColumn = columns.find(column => column.key === 'actions')

    if (actionsColumn) {
      const handleDeleteProduct = (record: DataSourceType): void => {
        onClickDelete(record)
      }

      actionsColumn.render = (_, record) => (
        <div className={ styles.productCardForm__tableActions }>
          { /* TODO: Раскоментировать и добавить логику, как будет готов бэк */ }
          { /* <LntButton
              type={ BUTTON_TYPE.link }
              size={ SIZE.small }
            >
              <StarOutlined />
            </LntButton> */ }

          <LntButton
            type={ BUTTON_TYPE.link }
            size={ SIZE.small }
            onClick={ () => handleDeleteProduct(record) }
          >
            <DeleteOutlined />
          </LntButton>
        </div>
      )
    }
  }, [columns])
}
